import { createActionGroup, props } from '@ngrx/store';
import { AbortInterruptedSessionProps } from './models/props/abort-interrupted-session.props';
import { LoadUploadSessionsErrorProps } from './models/props/load-upload-sessions-error.props';
import { LoadUploadSessionsSuccessProps } from './models/props/load-upload-sessions-success.props';
import { LoadUploadSessionsProps } from './models/props/load-upload-sessions.props';
import { ResumeVideoUploadProps } from './models/props/resume-video-upload.props';
import { SetSequenceUploadInfoProps } from './models/props/set-sequence-upload-info.props';
import { UpdateVideoUploadProgressProps } from './models/props/update-video-upload-progress.props';
import { UploadSequenceVideosProps } from './models/props/upload-sequence-videos.props';
import { VideoUploadErrorProps } from './models/props/video-upload-error.props';
import { VideoUploadReference } from './models/video-upload-reference';
import { VIDEO_UPLOADS_FEATURE_KEY } from './video-uploads.selectors';

export const videoUploadsActions = createActionGroup({
  source: VIDEO_UPLOADS_FEATURE_KEY,
  events: {
    // Fetches one client's ongoing upload sessions from the server (e.g. on reload).
    // Dispatched once per client the user can upload long videos for, so the sync-center gathers them all.
    'Load upload sessions': props<LoadUploadSessionsProps>(),
    'Load upload sessions success': props<LoadUploadSessionsSuccessProps>(),
    'Load upload sessions error': props<LoadUploadSessionsErrorProps>(),

    // Entry point: dispatched on sequence creation/edition with videos. Seeds the sync-center store
    // in the reducer (so a queued batch shows immediately) and drives the upload effect.
    'Upload sequence videos': props<UploadSequenceVideosProps>(),

    // Re-picks the file of an interrupted video and restarts its upload from scratch.
    'Resume video upload': props<ResumeVideoUploadProps>(),

    // Aborts the dead interrupted session server-side so it is not re-hydrated on next load.
    'Abort interrupted session': props<AbortInterruptedSessionProps>(),

    // Removes one video from the store (drops the sequence when it was its last video).
    'Remove video upload': props<VideoUploadReference>(),

    // Fills a hydrated interrupted sequence with its patient name (title) and creation date,
    // fetched from the sequence endpoint since the session payload doesn't carry them.
    'Set sequence upload info': props<SetSequenceUploadInfoProps>(),

    'Update video upload progress': props<UpdateVideoUploadProgressProps>(),
    'Video upload success': props<VideoUploadReference>(),
    'Video upload error': props<VideoUploadErrorProps>(),
  },
});
